<template>

  <div class="p-2">
    
    <div class="row align-items-center ">

      <div v-for="(opcion, index) in opciones" :key="index" :class="opcion.tipo === 'date' ? 'col-12' : 'col-6'">
        <div v-if="opcion.tipo === 'select'" class="row mb-1 d-flex align-items-center">
          <label :for="opcion.variable" class="col-7">
            {{ opcion.label }}:
          </label>

          <b-form-select
            v-model="dataAntecedentes[opcion.variable]"
            :options="opcion.options"
            class="col-5"
            :id="opcion.variable"
          />
        </div>
        <div v-else-if="opcion.tipo !== 'date'" class="row mb-1 d-flex align-items-center">
          <label :for="opcion.variable" class="col-7">
            {{ opcion.label }}:
          </label>

          <b-form-input v-model="dataAntecedentes[opcion.variable]" type="text" class="col-5" :id="opcion.variable"
            :maxlength="opcion.tipo === 'number' ? 2 : null"
            @keypress="opcion.tipo === 'number' ? onlyNumbers($event) : null" />
        </div>
        <div v-if="opcion.tipo === 'date'" class="row my-1 d-flex align-items-center">
          <label :for="opcion.variable" class="col-4">
            {{ opcion.label }}:
          </label>
          <b-form-input class="col-7" v-if="opcion.tipo === 'date'" v-model="dataAntecedentes[opcion.variable]"
            placeholder="descripcion" />

        </div>
      </div>
    </div>

    <div class="row my-1">
      <div class="col">
        
      <label>Elija metodo anticonceptivo</label>
          <b-form-checkbox-group
            v-model="dataAntecedentes.anticonceptivos"
            :options="opcionesAnticonceptivas"
            
            value-field="value"
            text-field="text"
           
          ></b-form-checkbox-group>
      </div>
     
      
      
    </div>


    <div class="row">
      <label for="" class="col-12">Analisis:</label>
      <b-form-textarea v-model="dataAntecedentes.analisis" class="col-11 mx-1" />
    </div>
  </div>
</template>

<script>
import { onlyNumbers } from "@/shared/helpers";
import { loadRespaldo, saveRespaldo } from '@/views/atencionCita/helpers';
import { ginecologiaService } from "@/views/atencionCita/services";
import { mapState } from "vuex";

export default {

  name: "Form013aSemioGineco",

  created() {
    //this.loadData();
  },

  props:{
    dataGinecologia :{
        deep:true,
        immediate:true
    }
  },

  data() {
    return {
      
      opcionesAnticonceptivas: [
          { value: '1', text: 'Oral o Inyectable' },
          { value: '2', text: 'DIU' }, 
          { value: '3', text: 'Ligadura' },
          { value: '4', text: 'Barrera' },    
          { value: '5', text: 'Implante' },   
          { value: '6', text: 'Otro' }    
        ],

      onlyNumbers,
      tokenAtencion: null,
      entroUnaVez: false,
      dataDesdeAtencion:null,

      dataAntecedentes: {
        anticonceptivos: [],
        menarquia: "",
        menopausia: "",
        ciclos: "",
        inicioSexual: "",
        gestas: "",
        partos: "",
        abortos: "",
        cesareas: "",
        hijosVivos: "",
        planificacionFamiliar: "",
        terapiaHormonal: "",
        ultimaMenstruacion: "",
        ultimoParto: "",
        citologiaCervical: "",
        colposcopia: "",
        mamografia: "",
        antigenoProstatico: "",
        ecoProstatico: "",
        analisis: "",
      },


      opciones: [
        {
          label: "Edad Menarquia",
          variable: "menarquia",
          tipo: "number"
        },
        {
          label: "Edad Menopausia",
          variable: "menopausia",
          tipo: "number"
        },
        {
          label: "Ciclos",
          variable: "ciclos",
          tipo: "select",
          options: [
            { value: "1", text: "Regular" },
            { value: "2", text: "Irregular" },
          ],
        },
        {
          label: "Edad inicio vida sexual",
          variable: "inicioSexual",
          tipo: "number"
        },
        {
          label: "Número de gestas",
          variable: "gestas",
          tipo: "number"
        },
        {
          label: "Número de partos",
          variable: "partos",
          tipo: "number"
        },
        {
          label: "Número de abortos",
          variable: "abortos",
          tipo: "number"
        },
        {
          label: "Número de cesáreas",
          variable: "cesareas",
          tipo: "number"
        },
        {
          label: "Número de hijos vivos",
          variable: "hijosVivos",
          tipo: "number"
        },

        {
          label: "Metodo de planificacion familiar",
          variable: "planificacionFamiliar",
          tipo: "text"
        },

        {
          label: "Terapia hormonal",
          variable: "terapiaHormonal",
          tipo: "text"
        },

        {
          label: "Fecha última menstruación",
          variable: "ultimaMenstruacion",
          tipo: "date"
        },
        {
          label: "Fecha último parto",
          variable: "ultimoParto",
          tipo: "date"
        },
        {
          label: "Fecha última citologia cervical",
          variable: "citologiaCervical",
          tipo: "date"
        },
        {
          label: "Fecha última colposcopia",
          variable: "colposcopia",
          tipo: "date"
        },
        {
          label: "Fecha última mamografia",
          variable: "mamografia",
          tipo: "date"
        },

        {
          label: "Fecha ultimo antigeno prostático",
          variable: "antigenoProstatico",
          tipo: "date"
        },

        {
          label: "Fecha ultimo eco prostático",
          variable: "ecoProstatico",
          tipo: "date"
        }
      ],


    }
  },



  methods: {
    normalizeCiclosValue(value) {
      if (value === null || value === undefined || value === "") return "";

      const normalizedValue = String(value).trim().toLowerCase();
      const normalizedMap = {
        "1": "1",
        "2": "2",
        regular: "1",
        irregular: "2",
      };

      return normalizedMap[normalizedValue] || "";
    },

    normalizeDataAntecedentes(data = {}) {
      return {
        ...this.dataAntecedentes,
        ...data,
        ciclos: this.normalizeCiclosValue(data?.ciclos),
      };
    },


    async loadData() {
      this.idCita = this.$route.params.id;
      this.tokenAtencion = this.$route.params.token;
      this.identificadorAtencion = this.idCita ? this.idCita : this.tokenAtencion;

      if (this.idCita) {
        const dataLS = loadRespaldo(this.identificadorAtencion, 'antecedentesGinecologicos');
        if (!dataLS) return;
        this.dataAntecedentes = dataLS;
      }

      if (this.tokenAtencion) {
        const responseGineco = await ginecologiaService.getAntecedentesByAtencion(this.tokenAtencion);
        if (!responseGineco) return;

        const respaldoEdit = {
          tokenAntecedentes: responseGineco.token,
          items: responseGineco.dataItems
        };

        saveRespaldo(this.identificadorAtencion, 'antecedentesGinecologicos', respaldoEdit);
        this.dataAntecedentes = responseGineco.dataItems;
      }
    },


  },


  watch: {
    dataGinecologia: {
      deep:true,
      immediate:true,
      async handler(newValue) {
        if (newValue){
          this.dataAntecedentes = this.normalizeDataAntecedentes(newValue)
        }
      }
    },

    dataAntecedentes: {
      deep: true,
      immediate:true,
      handler(newValue) {
        this.$emit('semiologia-enviada', newValue);
        
      }
    }
  },



}
</script>
